// Basic form components
export { default as FormAutocomplete } from "./FormAutocomplete";
export { default as FormButton } from "./FormButton";
export { default as FormCheckboxGroup } from "./FormCheckboxGroup";
export { default as FormDatepicker } from "./FormDatepicker";
export { default as FormInput } from "./FormInput";
export { default as FormNumberInput } from "./FormNumberInput";
export { default as FormPhoneInput } from "./FormPhoneInput";
export { default as FormPhotoUpload } from "./FormPhotoUpload";
export { default as FormRangeInput } from "./FormRangeInput/index";
export { default as FormSelect } from "./FormSelect";
export { FormStepsBreadcrumbs } from "./FormStepsBreadcrumbs";
export { default as FormSwitch } from "./FormSwitch";
export { default as FormTextarea } from "./FormTextarea";
export { default as FormUpload } from "./FormUpload";
export { default as FormWrapper } from "./FormWrapper";
export { default as SectionTitle } from "./SectionTitle";
export { default as SelectField } from "./SelectField";
export { default as SubSectionTitle } from "./SubSectionTitle";
export { default as TextControl } from "./TextControl";

// Multilingual form components
export { default as FormMultiLingualInput } from "./FormMultiLingualInput";
export { default as FormMultiLingualTextarea } from "./FormMultiLingualTextarea";

// Multi-step form components
export type { Step } from "@/types/form.types";
export type {
  UseFormStepsProps,
  UseFormStepsReturn,
} from "@/ui/AddObject/hooks/useFormSteps";

// Types and interfaces
export type { FormInputProps } from "./FormInput";
export type { FormNumberInputProps } from "./FormNumberInput";
export type { FormSelectProps, SelectOption } from "./FormSelect";
export type { FormTextareaProps } from "./FormTextarea";
export type { FormWrapperProps } from "./FormWrapper";
// export type {
//   FormMultiSelectProps,
//   MultiSelectOption,
// } from "./FormMultiSelect";
export type { FormAutocompleteProps } from "./FormAutocomplete";
export type {
  CheckboxOption,
  FormCheckboxGroupProps,
} from "./FormCheckboxGroup";
export type { FormDatepickerProps } from "./FormDatepicker";
export type {
  FormMultiLingualInputProps,
  SupportedLanguage,
} from "./FormMultiLingualInput";
export type { FormMultiLingualTextareaProps } from "./FormMultiLingualTextarea";
export { deserializePhotos, serializePhotos } from "./FormPhotoUpload";
export type { FormPhotoUploadProps } from "./FormPhotoUpload";
export type { FormRangeInputProps } from "./FormRangeInput/index";
export type { FormSwitchProps } from "./FormSwitch";
export type { FormUploadProps, UploadedFile } from "./FormUpload";
// export type { FormRadioGroupProps, RadioOption } from "./FormRadioGroup";
export type { FormButtonProps } from "./FormButton";
export type { FormPhoneInputProps } from "./FormPhoneInput";
// Defining AutocompleteOption as an alias for SelectOption
export type { SelectOption as AutocompleteOption } from "./FormSelect";
